module.exports = __webpack_public_path__ + "img/mod_4.7d556111.png";